import classNames from "classnames";
import * as React from "react";
import Render from "source/app/presentation/Shared/Render";
import { Sounds } from "source/app/services/Sound/Sounds";
import { Style, StyleClass } from "../../../../Shared/Styles/CSS";
import { ISwitchProps } from "./ISwitchProps";
import * as styles from "./Switch.css";
import { Slider } from "./SwitchSlider/SwitchSlider";

export function Switch(props: ISwitchProps) {
    const [isFocus, setIsFocus] = React.useState<boolean>(false);

    const grayedOutStyle = StyleClass("readonly", { opacity: 0.5 });

    const focusStyle = StyleClass("switchFocusStyle", {
        boxShadow: `0px 0px 10px gold`,
        borderRadius: `5px`,
    });

    return (
        <span
            className={classNames(props.withClasses, styles.container, {
                [grayedOutStyle]: props.readonly === true,
                [focusStyle]: isFocus,
            })}
            style={{
                display: props.displayInline ? `inline` : `block`,
            }}
        >
            <LabelLeft label={props.label} />
            <label className={styles.toggle}>
                <input
                    type="checkbox"
                    onFocus={() => setIsFocus(true)}
                    onBlur={() => setIsFocus(false)}
                    onChange={(e) => {
                        if (props.readonly === true) {
                            return;
                        }

                        Sounds.switch_toggle.Play();
                        props.onChange(e.target.checked);
                    }}
                    checked={props.isChecked}
                />
                <Slider
                    key={props.completionEventId}
                    isChecked={props.isChecked}
                    backgroundColor={props.backgroundColor}
                />
            </label>
            <Render id="labelRight" when={props.labelRight !== undefined}>
                <LabelRight label={props.labelRight!} />
            </Render>
        </span>
    );
}

const LabelLeft = ({ label }: { label: string }) => {
    const labelLeftStyle = Style(`labelLeft_${label}`, {
        right: "5px",
        fontSize: "9px",
        position: "relative",
        color: `dimgray`,
        bottom: "3px",
        fontWeight: `normal`,
    });

    return <span {...labelLeftStyle}>{label}</span>;
};

const LabelRight = ({ label }: { label: string }) => (
    <span
        {...Style(`labelRight_${label}`, {
            fontSize: `9px`,
            color: `dimgray`,
            position: `relative`,
            left: `4px`,
            bottom: `2px`,
            fontWeight: `normal`,
        })}
    >
        {label}
    </span>
);
